import React, { useState, useEffect } from 'react'
import { Container, Form, Modal, Button } from 'react-bootstrap'
import _ from "lodash"
import { isEmpty, filter, find, isArray, isString, get, indexOf } from "lodash"
import Select from 'react-select';
import { navigate } from "@reach/router";
import { navigate as gatsbyNavigate } from "gatsby";
import MoreFilter from "../MoreFilter/MoreFilter";
import { connectRefinementList, RefinementList } from "react-instantsearch-dom"
import $ from 'jquery'
import { propertyTypes, priceminRangeResiSale, pricemaxRangeResiSale, priceminRangeResiRent, pricemaxRangeResiRent, bedroomsRange, resiSalesPropertyType, resiLettingsPropertyType, OffPlanPropertyType, BannerpropertyTypes, completionRange } from "../../components/common/propertyUtils";
import SearchListBox from "../predictive-search/search-multiareas";
import AreaListBox from "./AreaList";
import '../SearchSelect/SearchSelect.scss';
import '../MoreFilter/MoreFilter.scss'
import { isIOS, isMacOs } from 'react-device-detect';


function PropertyFilter(props) {
    // console.log(props,"poopoo")
    // Common Search Navigate
    const pyOptions = propertyTypes
    const onChangeSellRent = (e) => {
        gatsbyNavigate(`/${e.value}`)
    }
    // 
    // Search Filter States
    // 
    const [areaVal, setAreaVal] = useState('');
    const [amenities, setAmenities] = useState('');
    const [closeState, setCloseState] = React.useState(false);
    const [areaRefineList, setAreaRefineList] = useState([]);
    const [areasArr, setAreasArr] = useState([]);
    const [areasList, setAreasList] = useState([]);
    const [checkedAmenities, setCheckedAmenities] = useState([]);
    const [ismapview, setIsmapview] = useState(true);
    const [minpriceVal, setMinPriceVal] = useState('');
    const [maxpriceVal, setMaxPriceVal] = useState('');
    const [minbedroomVal, setMinBedroomVal] = useState('');
    const [maxbedroomVal, setMaxBedroomVal] = useState('');
    const [propertyval, setPropertyVal] = useState('');
    const [completionVal, setCompletionVal] = useState('');
    const [dateval, setDateVal] = useState('');
    const [rentalperiod, setRentalPeriod] = useState('');
    const [furnishval, setFurnishVal] = useState('');
    const [parkingval, setParkingVal] = useState('');
    const [viewingval, setViewingVal] = useState('');
    const [salesVal, setSalesVal] = useState('');
    const [bedVal, setBedVal] = useState('');
    const [bathVal, setBathVal] = useState('');
    const [sqftVal, setSqftVal] = useState('');
    const [minsqftVal, setMinSqftVal] = useState('');
    const [maxsqftVal, setMaxSqftVal] = useState('');
    const [minPriceList, setMinPriceList] = useState([]);
    const [maxPriceList, setMaxPriceList] = useState([]);
    const [minBedroomList, setMinBedroomList] = useState([]);
    const [maxBedroomList, setMaxBedroomList] = useState([]);
    const [selectedMinPriceValue, setSelectedMinPriceValue] = useState(0);
    const [selectedMaxPriceValue, setSelectedMaxPriceValue] = useState(0);
    const [selectedMinBedroomValue, setSelectedMinBedroomValue] = useState(0);
    const [selectedMaxBedroomValue, setSelectedMaxBedroomValue] = useState(0);
    let defaultArea = "dubai";

    const handleMultiAreaFun = (val) => {
        let areas = [];
        if (isEmpty(find(areasArr, val))) {
            areas = [...areasArr]
            areas.push(val)
            setAreasArr(areas)
        }
    }
    const removeArea = (area, clear = false) => {
        if (!clear) {
            let prevAreas = areasArr.filter(x => x.slug !== area)
            setAreaVal('');
            setAreasArr(prevAreas);
        } else {
            setAreasArr([]);
            setAreaVal('');
            setAreasList([]);
        }
    }



    // 
    // Show Hide More Filter
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    // 
    ///// Price Filter Set /////
    // Min price
    const onChangeMinPrice = (e) => {
        setSelectedMinPriceValue(e.value);
    }
    // Min price

    // Max Price
    const onChangeMaxPrice = (e) => {
        setSelectedMaxPriceValue(e.value);
    }
    // Max Price

    // Min bedroom
    const onChangeMinBedroom = (e) => {
        setSelectedMinBedroomValue(e.value);
    }
    // Min bedroom

    // Sales price list
    var minPrice = [];
    var maxPrice = pricemaxRangeResiSale.filter(c => (c.value === "0" || parseInt(c.value) > parseInt(selectedMinPriceValue)));

    priceminRangeResiSale.map(items => parseInt(items.value) < parseInt(selectedMaxPriceValue) && minPrice.push(items));

    if (minPrice.length > 0) {
    } else {
        minPrice.push(priceminRangeResiSale[0])
    }

    if (maxPrice.length > 0) {
    } else {
        maxPrice.push(pricemaxRangeResiSale[0])
    }
    // Sales price list

    // Lettings price list
    var minPriceLettings = [];
    var maxPriceLettings = pricemaxRangeResiRent.filter(c => (c.value === "0" || parseInt(c.value) > parseInt(selectedMinPriceValue)));

    priceminRangeResiRent.map(items => parseInt(items.value) < parseInt(selectedMaxPriceValue) && minPriceLettings.push(items));

    if (minPriceLettings.length > 0) {
    } else {
        minPriceLettings.push(priceminRangeResiRent[0])
    }

    if (maxPriceLettings.length > 0) {
    } else {
        maxPriceLettings.push(pricemaxRangeResiRent[0])
    }
    // Lettings price list

    // 
    useEffect(() => {
        // 
        if (_.isEmpty(minPriceList)) {
            if (props.type === "lettings") {
                setMinPriceList(priceminRangeResiRent);
                setMaxPriceList(pricemaxRangeResiRent);
            } else {
                setMinPriceList(priceminRangeResiSale)
                setMaxPriceList(pricemaxRangeResiSale)
            }
        }
        //

        if (_.isEmpty(minBedroomList)) {
            setMinBedroomList(bedroomsRange)
        }

        // Page when load field in text boxes will same
        const url = typeof window !== 'undefined' ? window.location.href : ''
        let pathUri = url.split("/")
        for (let vi = 1; vi <= pathUri.length; vi++) {
            // check for area
            if (typeof pathUri[vi] === "undefined") {
                continue
            }

            // Property type
            if (pathUri[vi].indexOf("type-") >= 0) {
                setPropertyVal(pathUri[vi].replace("type-", ""))
            }
            // Property type

 // Completion date
 if (pathUri[vi].indexOf("date-") >= 0) {
    setDateVal(pathUri[vi].replace("date-", ""))
  }
            // Area
            // if ((pathUri[vi].indexOf("in-") == 0) && (pathUri[vi].indexOf("in-london") == -1)) {
            //     setAreaVal(_.upperFirst(pathUri[vi].replace("in-", "")))
            // }
            // Area

            // Price
            if (
                pathUri[vi].indexOf("between-") >= 0 ||
                pathUri[vi].indexOf("over-") >= 0 ||
                pathUri[vi].indexOf("under-") >= 0
            ) {
                let priceFilt1 = pathUri[vi].split("over-")
                if (priceFilt1[1]) {
                    setMinPriceVal(priceFilt1[1])
                }
                let priceFilt2 = pathUri[vi].split("under-")
                if (priceFilt2[1]) {
                    setMaxPriceVal(priceFilt2[1])
                }
                let priceFilt3 = pathUri[vi].split("between-")
                if (priceFilt3[1]) {
                    let priceFilt4 = priceFilt3[1].split("-and-")
                    setMinPriceVal(priceFilt4[0])
                    setMaxPriceVal(priceFilt4[1])
                }
            }
            // Price

            // Bedrooms Range
            if (
                pathUri[vi].indexOf("from-") >= 0 ||
                pathUri[vi].indexOf("to-") >= 0 ||
                pathUri[vi].indexOf("bedrooms-to-") >= 0
            ) {
                let bedroomFilt1 = pathUri[vi].split("from-")
                if (bedroomFilt1[1]) {
                var splitbed1 = bedroomFilt1[1].split("-bedrooms")
                if(bedroomFilt1[1].indexOf("to-") <= 0) {
                    //console.log("11111 minbed", splitbed1[0]);
                    setMinBedroomVal(splitbed1[0])
                }
                }
                let bedroomFilt2 = pathUri[vi].split("to-")
                if (bedroomFilt2[0] == "" && bedroomFilt2[1]) {
                    var splitbed2 = bedroomFilt2[1].split("-bedrooms")
                    setMaxBedroomVal(splitbed2[0])
                    //console.log("11111 maxbed", splitbed2[0]);
                }
                let bedroomFilt3 = pathUri[vi].split("bedrooms-")
                if (bedroomFilt3[0] && bedroomFilt3[1]) {
                if(bedroomFilt3[0].indexOf("from-") >= 0) {
                    var splitbed3 = bedroomFilt3[0].split("from-")            
                    setMinBedroomVal(splitbed3[1].replace(/-/g,""))
                    //console.log("1111122222 minbed", splitbed3[1].replace(/-/g,""));
                }
                if(bedroomFilt3[1].indexOf("to-") >= 0) {
                    var splitbed4 = bedroomFilt3[1].split("to-")
                    setMaxBedroomVal(splitbed4[1].replace(/-bedrooms/g, ""))
                    //console.log("1111122222 maxbed", splitbed4[1].replace(/-bedrooms/g, ""));

                }
                
                
                }
            }
            // Bedrooms Range

            // Bedrooms
            if (pathUri[vi].indexOf("-and-more-") >= 0) {
                setBedVal(pathUri[vi].replace("-and-more-bedrooms", ""))
            }
            // Bedrooms

        }
        // Page when load field in text boxes will same
    }, []);


    useEffect(() => {


        if (props.searchState?.refinementList?.search_areas) {
            let searchAreas = props.searchState.refinementList.search_areas;
            if (searchAreas !== defaultArea) {
                if (isString(searchAreas)) {
                    searchAreas = [searchAreas]
                }
                setAreaRefineList(searchAreas);
            }
        }
        //alert("test");
    }, [props.searchState?.refinementList])


    React.useEffect(() => {
        // if (amenities.length > 0) {
        //   for (var i = 0; i < amenities.length; i++) {
        //     $('.amenities-refine input[type="checkbox"][value="' + amenities[i] + '"]').prop('checked', 'checked');
        //   }
        // }
        if (props.searchState?.refinementList?.search_areas && areasList.length) {
            let search_areas = props.searchState.refinementList.search_areas;
            if (search_areas !== defaultArea) {
                let defaultRefineItems = []
                if (isString(search_areas)) {
                    search_areas = [search_areas]
                }
                search_areas.map((item) => {
                    let itemObj = find(areasList, ['slug', item])
                    if (!isEmpty(itemObj)) {
                        defaultRefineItems.push(itemObj)
                    }
                });

                setAreasArr(defaultRefineItems);
                setAreaRefineList(search_areas);
            }

        }
    }, [areasList, props.searchState?.refinementList?.search_areas])


    // 
    //  Submit Form on Mobile Sort
    useEffect(() => {
        let element = document?.getElementsByClassName('search-results-page')[0]
        if (closeState && element) {
            element?.classList?.add("filter_modal");
        } else {
            element?.classList?.remove("filter_modal");
        }    

    },[closeState])
    const HandleSort = (e) => {
        var searchFilterResults = 'sortby-' + e;
        navigate(searchFilterResults);
    }
    // Submit search
    const submitSearch = (e) => {
        $('.price-filter-dropdown').removeClass("active");
        //console.log('aaaaaaaaaaaprops',props.searchState)
        var areaValue = []
        if (areaRefineList) {
            let areasToRefine = []
            // let areasForUrl = []
            areasArr.map((a) => {
                if (a) {
                    areasToRefine.push(a.slug)
                    // areasForUrl.push(a.slug)
                }
            })
            setAreaRefineList(areasToRefine)
            areaValue = areasToRefine
        }
        var bedroomValue = bedVal ? bedVal : $(".bedroom-input input[type='hidden']").val();
        var bathroomValue = bathVal ? bathVal : $(".bathroom-input input[type='hidden']").val();
        var buildingValue = propertyval ? propertyval : $(".property input[type='hidden']").val();
        var completionDateValue = dateval;
        let priceUrl = ""
        if (maxpriceVal || minpriceVal) {
            if (minpriceVal && maxpriceVal && minpriceVal != "0" && maxpriceVal != "0") {
                priceUrl = "between-" + minpriceVal + "-and-" + maxpriceVal
            } else
                if ((minpriceVal == '' || minpriceVal == "0") && maxpriceVal && maxpriceVal != "0") {
                    priceUrl = "under-" + maxpriceVal
                }
                else if (minpriceVal && (maxpriceVal == '' || maxpriceVal == "0") && minpriceVal != "0") {
                    priceUrl = "over-" + minpriceVal
                }
        }
        let bedUrl = ""
        if (minbedroomVal) {
            if (minbedroomVal && minbedroomVal != "0") {
                bedUrl = "from-" + minbedroomVal + "-bedrooms"
            }
        }
        var searchFilterResults = "";
        // console.log("areaValueareaValue", areaValue)
        // var keywordareaval = 'dubai';
        var keywordareaval = $(".areas-list-wrap .react-autosuggest__input").val();
        // console.log("areaValueareaValue", keywordareaval)
        if (isArray(areaValue) && areaValue.length == 0 && keywordareaval.length > 0) {
            areaValue.push(keywordareaval.replace(/\s+/g, '-'));
        }

        if (isArray(areaValue)) {
            if (areaValue.length > 0) {
                searchFilterResults = `${props.propertyCategory==="off-plan-property"?"/off-plan-property/": props.propertyCategory==="off-plan"?"/off-plan-projects/":"/property/"}` + props.ptypetag + "/in-" + areaValue.join("-and-") + "/";
            } else {
                searchFilterResults = `${props.propertyCategory==="off-plan-property"?"/off-plan-property/":props.propertyCategory==="off-plan"?"/off-plan-projects/":"/property/"}` + props.ptypetag + "/in-" + defaultArea + "/";
            }
        } else {
            searchFilterResults = `${props.propertyCategory==="off-plan-property"?"/off-plan-property/":props.propertyCategory==="off-plan"?"/off-plan-projects/":"/property/"}` + props.ptypetag + "/in-" + defaultArea + "/";
        }

        if (buildingValue) {
            searchFilterResults += "type-" + buildingValue + "/";
        }
        if (completionDateValue) {
            searchFilterResults += "date-" + completionDateValue + "/";
        }
        if (bedroomValue && bedroomValue != "0") {
            searchFilterResults += bedroomValue + "-and-more-bedrooms/";
        }
        if (bathroomValue && bathroomValue != "0") {
            searchFilterResults += bathroomValue + "-and-more-bathrooms/";
        }
        if (furnishval) {
            searchFilterResults += "furnished-" + furnishval + "/";
        }

        if (priceUrl) {
            searchFilterResults += priceUrl + "/";
        }
        if (bedUrl) {
            searchFilterResults += bedUrl + "/";
        }
        if (props.sort_by) {
            searchFilterResults += 'sortby-' + props.sort_by;
        }

        navigate(searchFilterResults);
        setCloseState(false)
    }
    // Submit search

    return (
        <>
            <div className='search-select'>
                <div className="d-none">
                    {(areaRefineList.length > 0) && (
                        <RefinementList
                            attribute="search_areas"
                            defaultRefinement={areaRefineList}
                        />
                    )}
                </div>

                <Form id="myForm" action="javascript:;" method="post" className='search-wrapper' onSubmit={submitSearch}>
                    <div className='location-search flex-grow-1'>
                        <div className={`${isMacOs || isIOS ? "Ios" : ""} filter-search-input-box`}>
                            <div className="dropdown areas-list-wrap">
                                <SearchListBox areaVal={areaVal} setAreaVal={setAreaVal} setAreasList={setAreasList} handleMultiAreaFun={handleMultiAreaFun} autosuggestInputProps={{ className: 'form-control react-autosuggest__input refine-autosuggest-input' }} />


                                {/* <Select className="react-select" classNamePrefix="react-select" defaultValue={optionsLocation[0]} options={optionsLocation} isSearchable={false} /> */}
                                {/* <i className="icon-location"></i> */}
                                {/* <Form.Control className='react-select' type="search" placeholder="Street, area or postcode" id="formBasicEmail" */}
                                {/* /> */}
                            </div>
                        </div>
                    </div>
                    <div className='rtl-block '>
                        <div className='d-none d-xl-inline-flex desk-filter'>
                            <Select
                                name="minprice"
                                //options={parseInt(selectedMaxPriceValue) === 0 ? minPriceList : minPrice}

                                options={parseInt(selectedMaxPriceValue) === 0 ? minPriceList : (props.type === "sales" ? minPrice : minPriceLettings)}


                                value={minPriceList.find(obj => obj.value === minpriceVal)}
                                isSearchable={false}
                                placeholder="Min Price"
                                className="react-select filter-opt"
                                classNamePrefix="react-select"
                                onChange={e => { onChangeMinPrice(e); setMinPriceVal(e.value) }}
                            />
                            <Select
                                name="maxprice"
                                //options={parseInt(selectedMinPriceValue) === 0 ? maxPriceList  : maxPrice}
                                options={parseInt(selectedMinPriceValue) === 0 ? maxPriceList : (props.type === "sales" ? maxPrice : maxPriceLettings)}

                                value={maxPriceList.find(obj => obj.value === maxpriceVal)}
                                isSearchable={false}
                                placeholder="Max Price"
                                className="react-select filter-opt"
                                classNamePrefix="react-select"
                                onChange={e => { onChangeMaxPrice(e); setMaxPriceVal(e.value) }}

                            />
                            <Select
                                name="minbedroom"
                                options={minBedroomList}
                                value={minBedroomList.find(obj => obj.value === minbedroomVal)}
                                isSearchable={false}
                                placeholder="Bedrooms"
                                className="react-select filter-opt"
                                classNamePrefix="react-select"
                                onChange={e => { onChangeMinBedroom(e); setMinBedroomVal(e.value) }}
                            />
                            {
                            // props.propertyCategory === "off-plan" ?
                            //     <Select
                            //         options={completionRange}
                            //         placeholderValue={"Completion Date"}
                            //         value={completionRange.find(obj => obj.value === completionVal)}
                            //         onChange={e => setCompletionVal(e.value)}
                            //         isSearchable={false}
                            //         className="react-select filter-opt"
                            //         classNamePrefix="react-select"
                            //     />
                            //     :
                                <Select
                                    options={props.type === "sales" && props.propertyCategory === "off-plan" ? OffPlanPropertyType : props.type === "sales" ? resiSalesPropertyType : resiLettingsPropertyType}
                                    placeholderValue={propertyval ? propertyval : "Property Type"}
                                    value={props.department === "residential" ? resiSalesPropertyType.find(obj => obj.value === propertyval) : props.propertyCategory === "off-plan" ? OffPlanPropertyType.find(obj => obj.value === propertyval) : resiLettingsPropertyType.find(obj => obj.value === propertyval)}
                                    onChange={e => setPropertyVal(e.value)}
                                    isSearchable={false}
                                    className="react-select filter-opt"
                                    classNamePrefix="react-select"
                                >
                                </Select>
                            }
                        </div>


                        <div className='btn-filter d-xl-none' onClick={() => setCloseState(true)}>
                            <i className='icon-filter d-md-block m-md-2 m-0'></i>
                            <span className="d-none d-md-inline-block mt-1">More Filters</span>
                        </div>

                        <button type="submit" className='search-btn'>
                            <i className='icon-search'></i>
                        </button>
                    </div>
                </Form>
            </div>
            <div className='reset-filter'>
                <a href={"/"+ `${props.propertyCategory==="off-plan-property"?"off-plan-property":props?.propertyCategory === "off-plan" ? "off-plan-projects" : "property"}` +"/" + props.ptypetag+"/in-dubai/"}>Reset Filters</a>
            </div>
            <AreaListBox areas={areasArr} removeArea={removeArea} />

            {
                closeState &&
                <Form id="myForm" action="javascript:;" method="post" className='search-wrapper' onSubmit={submitSearch}>
                    <div className='select-filter'>
                        <div className='close-btn' onClick={() => setCloseState(false)}>
                            <i className='icon-cross'></i>
                        </div>
                        {props.propertyCategory !== "off-plan" && 
                            <Select
                                options={propertyTypes}
                                placeholder={find(propertyTypes, ['label', (props.type === "sales" ? 'Buy' : 'Rent')])}
                                value={find(propertyTypes, ['label', (props.type === "sales" ? 'Buy' : 'Rent')])}
                                onChange={(e) => onChangeSellRent(e)}
                                isSearchable={false}
                                className="react-select filter-opt"
                                classNamePrefix="react-select"
                            />
                        }
                        <div className='location-search react-select'>
                            <div className={`filter-search-input-box`}>
                                <div className="dropdown areas-list-wrap">
                                    <SearchListBox areaVal={areaVal} setAreaVal={setAreaVal} setAreasList={setAreasList} handleMultiAreaFun={handleMultiAreaFun} autosuggestInputProps={{ className: 'form-control react-autosuggest__input refine-autosuggest-input' }} />
                                </div>
                            </div>
                        </div>
                        <AreaListBox areas={areasArr} removeArea={removeArea} />
                        {
                        // props.propertyCategory === "off-plan" ?
                        //     <Select
                        //         options={completionRange}
                        //         placeholderValue={"Completion Date"}
                        //         value={completionRange.find(obj => obj.value === completionVal)}
                        //         onChange={e => setCompletionVal(e.value)}
                        //         isSearchable={false}
                        //         className="react-select filter-opt"
                        //         classNamePrefix="react-select"
                        //     />
                        //     : 
                            <Select
                                options={props.type === "sales" && props.propertyCategory === "off-plan" ? OffPlanPropertyType : props.type === "sales" ? resiSalesPropertyType : resiLettingsPropertyType}
                                placeholderValue={propertyval ? propertyval : "Property Type"}
                                value={props.department === "residential" ? resiSalesPropertyType.find(obj => obj.value === propertyval) : props.propertyCategory === "off-plan" ? OffPlanPropertyType.find(obj => obj.value === propertyval) : resiLettingsPropertyType.find(obj => obj.value === propertyval)}
                                onChange={e => setPropertyVal(e.value)}
                                isSearchable={false}
                                className="react-select filter-opt"
                                classNamePrefix="react-select"
                            />
                        }
                        <Select
                            name="minprice"
                            //options={parseInt(selectedMaxPriceValue) === 0 ? minPriceList : minPrice}

                            options={parseInt(selectedMaxPriceValue) === 0 ? minPriceList : (props.type === "sales" ? minPrice : minPriceLettings)}


                            value={minPriceList.find(obj => obj.value === minpriceVal)}
                            isSearchable={false}
                            placeholder="Min Price"
                            className="react-select filter-opt"
                            classNamePrefix="react-select"
                            onChange={e => { onChangeMinPrice(e); setMinPriceVal(e.value) }}
                        />
                        <Select
                            name="maxprice"
                            //options={parseInt(selectedMinPriceValue) === 0 ? maxPriceList  : maxPrice}
                            options={parseInt(selectedMinPriceValue) === 0 ? maxPriceList : (props.type === "sales" ? maxPrice : maxPriceLettings)}

                            value={maxPriceList.find(obj => obj.value === maxpriceVal)}
                            isSearchable={false}
                            placeholder="Max Price"
                            className="react-select filter-opt"
                            classNamePrefix="react-select"
                            onChange={e => { onChangeMaxPrice(e); setMaxPriceVal(e.value) }}

                        />
                        {props.propertyCategory === "off-plan" && 
                            <Select
                                name="minbedroom"
                                options={minBedroomList}
                                value={minBedroomList.find(obj => obj.value === minbedroomVal)}
                                isSearchable={false}
                                placeholder="Bedrooms"
                                className="react-select filter-opt"
                                classNamePrefix="react-select"
                                onChange={e => { onChangeMinBedroom(e); setMinBedroomVal(e.value) }}
                            />
                        }
                        <div className='btn-panel'>
                            <button type="submit" className='update-btn'>Update Results</button>
                        </div>
                    </div>
                </Form>
            }

        </>
    )
}

export default PropertyFilter